
import { z } from "zod";

export const clientIntakeSchema = z.object({
  // Personal Information
  firstName: z.string().min(2, "First name must be at least 2 characters"),
  lastName: z.string().min(2, "Last name must be at least 2 characters"),
  email: z.string().email("Please enter a valid email address"),
  phone: z.string().min(10, "Phone number must be at least 10 digits"),
  
  // Company Information
  companyName: z.string().min(2, "Company name must be at least 2 characters"),
  industry: z.string().min(1, "Please select an industry"),
  companySize: z.string().refine((val) => ["1-10", "11-50", "51-200", "201-500", "500+"].includes(val), {
    message: "Please select company size",
  }),
  
  // Project Details
  projectType: z.array(z.string()).min(1, "Please select at least one project type"),
  budget: z.number().min(1000, "Budget must be at least $1,000"),
  timeline: z.string().min(1, "Please select a timeline"),
  projectDescription: z.string().min(50, "Project description must be at least 50 characters"),
  
  // Requirements
  requirements: z.string().optional(),
  attachments: z.array(z.instanceof(File)).optional(),
});

export const proIntakeSchema = z.object({
  // Personal Information
  firstName: z.string().min(2, "First name must be at least 2 characters"),
  lastName: z.string().min(2, "Last name must be at least 2 characters"),
  email: z.string().email("Please enter a valid email address"),
  phone: z.string().min(10, "Phone number must be at least 10 digits"),
  
  // Professional Information
  title: z.string().min(2, "Professional title is required"),
  experience: z.number().min(1, "Experience must be at least 1 year").max(50, "Experience cannot exceed 50 years"),
  skills: z.array(z.string()).min(1, "Please select at least one skill"),
  specializations: z.array(z.string()).min(1, "Please select at least one specialization"),
  
  // Availability
  availability: z.string().refine((val) => ["full-time", "part-time", "contract", "freelance"].includes(val), {
    message: "Please select availability",
  }),
  hourlyRate: z.number().min(10, "Hourly rate must be at least $10"),
  
  // Portfolio
  portfolioUrl: z.string().url("Please enter a valid URL").optional().or(z.literal("")),
  bio: z.string().min(100, "Bio must be at least 100 characters"),
  
  // Documents
  resume: z.instanceof(File).optional(),
  portfolio: z.array(z.instanceof(File)).optional(),
});

export type ClientIntakeFormData = z.infer<typeof clientIntakeSchema>;
export type ProIntakeFormData = z.infer<typeof proIntakeSchema>;
